import { Component, Input } from '@angular/core';
import { Buyer } from 'src/app/core/buyers.service';

@Component({
  selector: 'app-home-buyers-item',
  templateUrl: './home-buyers-item.component.html',
  styleUrls: ['./home-buyers-item.component.scss'],
})
export class HomeBuyersItemComponent {
  @Input() buyer?: Buyer;
}
